import { render, staticRenderFns } from "./ParametrosIniciativa.vue?vue&type=template&id=156fab1e&scoped=true"
import script from "./ParametrosIniciativa.vue?vue&type=script&lang=js"
export * from "./ParametrosIniciativa.vue?vue&type=script&lang=js"
import style0 from "./ParametrosIniciativa.vue?vue&type=style&index=0&id=156fab1e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156fab1e",
  null
  
)

export default component.exports